"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const ramda_adjunct_1 = require("ramda-adjunct");
exports.default = (keyNames = [], predicate, obj) => {
    if ((0, ramda_adjunct_1.isNotFunction)(predicate)) {
        return (0, ramda_adjunct_1.isNotNilOrEmpty)(obj) ? (0, ramda_1.pick)(keyNames)(obj) : (0, ramda_1.pick)(keyNames);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore FIXME: need typing for the below function
    const composedFn = (0, ramda_1.compose)((0, ramda_1.pickBy)(predicate), (0, ramda_1.pick)(keyNames));
    return (0, ramda_adjunct_1.isNotNilOrEmpty)(obj) ? composedFn(obj) : composedFn;
};
